import React, { Component } from 'react';
import md5 from 'md5';
import Config from '../config/config';

// import * as LoginActions from '../action/actionstore';
import login from '../stores/stores';

var data = {};
var getPropertyCode = '';
class LoginBox extends Component {
  constructor(props) {
    super(props);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.getPropertyCodeValue();
    this.logoURL ='images/unifocus-logo-name.png';
    this.showICPConfig = (Config && Config.showICP && Config.showICP()) || {};
    this.state = {
      isHidden: false
    };
  }
  componentDidMount() {
    if (localStorage.loginFailCount > 3) {
      login.createImage();
    }
  }

  handleChange(e) {
    data[e.target.id] = e.target.value;
  }

  handleKeyPress(e) {
    if (e.keyCode === 13) {
      this.handleSubmit();
    }
  }

  getPropertyCodeValue() {
    var cookiesData = document.cookie;
    if (cookiesData) {
      var storeJson = cookiesData.split('_propertyCode=')[1];
      if (storeJson) {
        storeJson = storeJson.split(';')[0];
        getPropertyCode = storeJson;
      }
    }
  }

  handleSubmit(event) {
    var properties = Config.propertiesWithAuthorization();
    var customerCode =
           data.customercode === undefined
           ? document.getElementById('custmorecode').value
           : data.customercode;
    if (properties.indexOf(customerCode) >= 0) {
      document.getElementById('btnSigning').style.display = 'none';
      document.getElementById('buttonsign').style.display = 'inline';
      document.getElementById('loginError').style.display = 'block';
      document.getElementById('loginErrorMsg').innerHTML =
         'Please go to <a class="redirect-link" id="redirection">'+Config.configURL().KnowcrossLogin+'</a>';
      document.getElementById(
         'redirection'
      ).href = Config.configURL().KnowcrossLogin;
      return;
    }

    login.goPreLogin({
      type: 'Login_fetch',
      text: {
        CustomerCode:
           data.custmorecode === undefined
           ? document.getElementById('custmorecode').value
           : data.custmorecode,
        UserName: data.username,
        captchaTextVal: data.captchaText,
        Password: data.password === undefined ? '' : data.password,
        DeviceId: '',
        DeviceType: 'DESKTOP',
        ProductCode: 'TRITON_CHECKLIST',
        ModuleCode: 'CHECKLIST_BASE_LICENSE',
        IsComingFromHTML: true //,
        //"IsNewAuth" : true
      }
    });

    document.getElementById('buttonsign').style.display = 'none';
    document.getElementById('btnSigning').style.display = 'inline';

    if (data.password === undefined) {
      data.password = '';
    }
    if (data.captchaText === undefined) {
      data.captchaText = '';
    }
    if (data.custmorecode === undefined) {
      data.custmorecode = document.getElementById('custmorecode').value;
    }
    var password = md5(data.password);

    // SET Property Code in cookie //
    var dateP = new Date();
    var Domain = Config.configURL().Domain;
    var dateP1 = dateP.getTime() + 365 * 24 * 60 * 60 * 1000;
    dateP.setTime(dateP1);
    var expiresP = dateP.toUTCString();
    var secureDomain = Config.secureDomain() || {};
    var secureFlag = secureDomain.cookie ? ';secure=true' : '';
    document.cookie =
       '_propertyCode=' +
       data.custmorecode +
       '; expires=' +
       expiresP +
       '; path=/;domain=' +
       Domain +
       secureFlag;
  }
  render() {
    return (
       <div>
         <div className="headerSection">
           <div className="pull-left">
             <img src="images/unifocus-logo-name.png" alt="Unifocus logo" height={"90px"}/>
           </div>
         </div>

         <div className="container">
           <div className="row">
             <div className="loginBox">
               <h3 className="buttomClass">&nbsp;</h3>
               <div className="panel panel-default backgroundImage loginBoxInner">
                 <div className="panel-body ">
                   <fieldset>
                     <div className="row">
                       <div className="centerLoginPadding">
                         {/*<img src="images/center-logo.png" alt="" />*/}
                       </div>
                     </div>
                     <div className="row">
                       <div>
                         <div id="loginError" className="alert alert-danger">
                           <span id="loginErrorMsg"></span>
                         </div>
                         <div className="form-group">
                           <div className="input-group">
                            <span className="input-group-addon ion-image">
                              <i className="icon-property"></i>
                            </span>
                             <input
                                className="form_text_color form-control loginuser"
                                placeholder="Property Code"
                                defaultValue={getPropertyCode}
                                onChange={this.handleChange}
                                id="custmorecode"
                                type="text"
                                name="custmorecode"
                                onKeyDown={this.handleKeyPress}
                                autoFocus
                             />
                           </div>
                         </div>
                         <div className="form-group">
                           <div className="input-group">
                            <span className="input-group-addon ion-image">
                              <i className="glyphicon glyphicon-user"></i>
                            </span>
                             <input
                                className="form_text_color form-control loginuser"
                                id="username"
                                onChange={this.handleChange}
                                placeholder="Username"
                                name="loginname"
                                type="text"
                                onKeyDown={this.handleKeyPress}
                             />
                           </div>
                         </div>
                         <div className="form-group">
                           <div className="input-group">
                            <span className="input-group-addon ion-image">
                              <i className="glyphicon glyphicon-lock"></i>
                            </span>
                             <input
                                className="form_text_color form-control loginuser"
                                id="password"
                                placeholder="Password"
                                onChange={this.handleChange}
                                name="password"
                                type="password"
                                onKeyDown={this.handleKeyPress}
                             />
                           </div>
                         </div>
                         <div className="form-group" id="captcha">
                           <div
                              className="input-group captchaHide"
                              id="captchaMainDiv"
                           >
                             <div id="canvasDiv" className="">
                               <canvas
                                  id="mycanvas"
                                  className="captchaBorder captchaDefault"
                               >
                                 {' '}
                               </canvas>
                             </div>
                             <input
                                className="form_text_color form-control loginuser captchaTextBox"
                                id="captchaText"
                                placeholder="Enter captcha"
                                name="captchaText"
                                type="text"
                                onChange={this.handleChange}
                                onKeyDown={this.handleKeyPress}
                             />
                           </div>
                           <span className="capError"> </span>
                         </div>
                         <div className="form-group newBtn">
                           <button
                              type="submit"
                              id="buttonsign"
                              onClick={this.handleSubmit}
                              className="btn btn-primary btn-block signIn"
                           >
                             Sign in
                           </button>
                           <button
                              id="btnSigning"
                              className="btn btn-primary btn-block signIn"
                           >
                             Signing in..
                           </button>
                         </div>
                       </div>
                     </div>
                   </fieldset>
                 </div>
               </div>
             </div>
           </div>
         </div>

         <div className="footerSection centered-toolbar">
           <div className="left-container">
             <table className="addr_table  toolbar-items">
               <tbody>
               <tr>
                 <td colSpan="2">
                   <div className="button-wrapper">
                     <a target="_blank" className="footer-link" href="https://ufjira.atlassian.net/servicedesk/customer/portal/10">unifocus
                       support</a>
                   </div>
                 </td>
               </tr>

               <tr>
                 <td>AMERICAS</td>
                 <td>+1 469 351 7595</td>
                 <td>| +1 800 819 3796</td>
               </tr>
               <tr>
                 <td>EUROPE</td>
                 <td>+44 20 3885 7478</td>
                 <td>| +44 800 088 5463</td>
               </tr>
               <tr>
                 <td>APAC</td>
                 <td>+65 3158 2568</td>
                 <td>| +65 800 492 2311</td>
               </tr>
               <tr>
                 <td>ROW</td>
                 <td>+91 989 912 3191</td>
               </tr>
               <tr>
                 <td>Email</td>
                 <td colSpan="3">
                   <a
                      href="mailto:globalsupport@unifocus.com"
                      className="mail_link"
                   >
                     globalsupport[at]unifocus[dot]com
                   </a>
                 </td>
               </tr>
               </tbody>
             </table>
           </div>

           <div className="center-container">
             {this.showICPConfig && this.showICPConfig.displayICPLogo ? (
                <div className="domain-info">
                  {this.showICPConfig.displayPSBLogo ? (
                     <a
                        href={this.showICPConfig.PSBLink}
                        className="footer-link psb-link"
                        target="_blank"
                     >
                       {this.showICPConfig.PSBLabel}
                     </a>
                  ) : null}
                  {this.showICPConfig.displayPSBLogo ? (
                     <span>&nbsp; | &nbsp;</span>
                  ) : null}
                  <a
                     href={this.showICPConfig.ICPLink}
                     className="footer-link icp-link"
                     target="_blank"
                  >
                    {this.showICPConfig.ICPLabel}
                  </a>
                </div>
             ) : null}
           </div>
           <div className="right-container">
             <div className="privacy-info toolbar-items">
               Copyright &copy; 2023 unifocus.com |{' '}
               <a
                  href="https://www.unifocus.com/privacy-policy"
                  className="privacyText footer-link"
                  target="_blank"
               >
                 Privacy Policy
               </a>
             </div>
           </div>
         </div>
       </div>
    );
  }
}

export default LoginBox;



// WEBPACK FOOTER //
// ./src/components/loginBox.js